import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsMenuStore {
  cmsUsername = window.localStorage.getItem('adminLoginName')?.replace(/(^['"]|['"]$)/g, '');

  @observable menuTypes = [
    { value: 'AMENITY', label: 'AMENITY' },
    { value: 'BOOKING_FACILITY', label: 'BOOKING_FACILITY' },
    { value: 'CONCIERGE', label: 'CONCIERGE' },
    { value: 'DEFECT_REPORT', label: 'DEFECT_REPORT' },
    { value: 'DND', label: 'DND' },
    { value: 'FRONT_OFFICE', label: 'FRONT_OFFICE' },
    { value: 'HK_SERVICE', label: 'HK_SERVICE' },
    { value: 'IN_ROOM_DINING', label: 'IN_ROOM_DINING' },
    { value: 'LATE_CHECKOUT', label: 'LATE_CHECKOUT' },
    { value: 'LAUNDRY', label: 'LAUNDRY' },
    { value: 'PRINT_FILE', label: 'PRINT_FILE' },
    { value: 'SHOPPING', label: 'SHOPPING' },
    { value: 'SPA', label: 'SPA' },
    { value: 'TRANSPORTATION', label: 'TRANSPORTATION' },
    { value: 'TV_CHANNEL', label: 'TV_CHANNEL' },
    { value: 'WAKE_UP_CALL', label: 'WAKE_UP_CALL' },
    { value: 'DAILY ACTIVITY', label: 'DAILY ACTIVITY' },
    { value: 'DIVE CENTER', label: 'DIVE CENTER' },
  ];

  @observable defaultMenuIcon = [
    { label: 'AMENITY', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logod7ac2351-852a-45b0-a973-ddb8a58d50bf.svg' },
    { label: 'BOOKING_FACILITY', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logoe4cfaf7d-07a0-48e6-8aff-07e8ffed86c3.svg' },
    { label: 'CONCIERGE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo8ff7880f-f30f-4d4a-95e3-ad8fbba27f74.svg' },
    { label: 'DEFECT_REPORT', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo33c25b0f-113e-4f67-a1e6-fde91b49401d.svg' },
    { label: 'DND', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo40f88512-3ce6-47ab-83ba-ad09d41928be.svg' },
    { label: 'FRONT_OFFICE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logodd08019d-78db-428f-8d7b-0f3e41762167.svg' },
    { label: 'HK_SERVICE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo21720f8e-dfd9-4902-980c-a0ab33f7e3bd.svg' },
    { label: 'IN_ROOM_DINING', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo6f7e5903-73ae-460f-ac18-f1615ed35809.svg' },
    { label: 'LATE_CHECKOUT', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo867ebbd4-673b-42e5-9250-ad3b40a40d2a.svg' },
    { label: 'LAUNDRY', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo95962417-6bf3-4321-a6a2-03a9ef713fdb.svg' },
    { label: 'PRINT_FILE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logofe96f90a-3d73-4adf-8271-84f367852096.svg' },
    { label: 'SHOPPING', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo63fb3e5b-1611-4581-84b4-2538370292b2.svg' },
    { label: 'SPA', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logoc4106d57-0b4c-45c4-861c-e5f41e73f5d6.svg' },
    { label: 'TRANSPORTATION', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo92df3691-f2e5-4ec1-8da2-8d60aeee3dca.svg' },
    { label: 'TV_CHANNEL', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground9ae5ed6d-20a8-415f-afda-1daf2457689c.svg' },
    { label: 'WAKE_UP_CALL', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/Logo03744e98-e3a2-404e-8cbe-e1ac41721f5e.svg' },
  ];

  @observable defaultMenuBanner = [
    { label: 'CONCIERGE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground4e0cc39f-6f0f-4a71-8919-17814893d964.svg' },
    { label: 'DEFECT_REPORT', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackgrounda8559ddc-75c5-4b6e-b335-83717721f251.svg' },
    { label: 'DND', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground978989d7-f592-4bf7-9712-0ebc50dcb3ce.svg' },
    { label: 'FRONT_OFFICE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground587bea92-6b2f-4b2d-8a97-7cb7c15d6c38.svg' },
    { label: 'HK_SERVICE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground5331bd5e-a0c2-4b8b-9731-874b5b3c0b25.svg' },
    { label: 'LATE_CHECKOUT', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground0d06078a-39c9-4cdb-bfc3-90b85985fa01.svg' },
    { label: 'PRINT_FILE', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackgroundb86b6f68-ce18-4054-b25a-d64a6fcf8ec3.png' },
    { label: 'TRANSPORTATION', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackground30f565ed-fde0-48de-b09f-95739827c840.svg' },
    { label: 'TV_CHANNEL', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackgroundcaa0c8f8-288c-4eb8-b129-605a5988cebe.svg' },
    { label: 'WAKE_UP_CALL', value: 'https://s3-ap-east-1.amazonaws.com/staymenu-images/CmsImage/LoginBackgroundb2e92f24-e70a-465d-b062-05f8e5c07d84.svg' },
  ];

  @observable data = [];
  @observable selectedData = null;

  @action getData() {
    this.selectedData = null;
    return apiCaller.CmsTasks.getMenus().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getActives() {
    return apiCaller.CmsTasks.getActiveMenus().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action update() {
    this.selectedData.updatedBy = this.cmsUsername;
    return apiCaller.CmsTasks.updateMenu(this.selectedData.taskID, this.selectedData);
  }

  @action enabledMenu(taskID) {
    return apiCaller.CmsTasks.enabledMenu(taskID);
  }

  @action disabledMenu(taskID) {
    return apiCaller.CmsTasks.disabledMenu(taskID);
  }

  @action edit(taskID) {
    this.selectedData = this.data.find(fi => fi.taskID === taskID);
  }

  @action cancelUpdate() {
    this.getData();
  }

  @action setimageUrl(value) {
    this.selectedData.imageUrl = value;
  }

  @action setDefaultImageUrl(menuType) {
    const defaultImageUrl = this.defaultMenuIcon.find(fi => fi.label === menuType);
    if (defaultImageUrl) {
      this.selectedData.imageUrl = defaultImageUrl.value;
    }
  }

  @action setstayPleaseTaskID(value) {
    this.selectedData.stayPleaseTaskID = value;
  }

  @action setisShown(value) {
    this.selectedData.isShown = value;
  }

  @action setisSoon(value) {
    this.selectedData.isSoon = value;
  }

  @action setsortID(value) {
    this.selectedData.sortID = value;
  }

  @action setvat(value) {
    this.selectedData.vat = value;
  }

  @action setserviceFee(value) {
    this.selectedData.serviceFee = value;
  }

  @action setbannerUrl(value) {
    this.selectedData.bannerUrl = value;
  }

  @action setmenuType(value) {
    this.selectedData.menuType = value;
  }

  @action isMenuTypeHasBanner(menuType) {
    const banner = this.defaultMenuBanner.find(fi => fi.label === menuType);

    if (banner) {
      return banner.value !== '';
    }

    return false;
  }

  @action setDefaultBanner(menuType) {
    const defaultBannerUrl = this.defaultMenuBanner.find(fi => fi.label === menuType);
    if (defaultBannerUrl) {
      this.selectedData.bannerUrl = defaultBannerUrl.value;
    }
  }
}

export default new CmsMenuStore();